import _implicitStylesheets from "./skillFileBrowser.css";
import _implicitScopedStylesheets from "./skillFileBrowser.scoped.css?scoped=true";
import _wdsIconInteractive from "wds/iconInteractive";
import _listingSearchInput from "listing/searchInput";
import _wdsFileTree from "wds/fileTree";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="files-heading${0}"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<p class="empty-message${0}"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<p class="filter-empty-message${0}"${2}>${"t1"}</p>`;
const stc0 = {
  "left-pane": true
};
const stc1 = {
  classMap: {
    "file-tree-header": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "file-tree-search": true
  },
  key: 5
};
const stc3 = {
  "file-search-control": true
};
const stc4 = {
  classMap: {
    "file-tree-body": true
  },
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3, _m4} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "role": "region",
      "aria-label": $cmp.packageFilesTreeLabel
    },
    key: 0
  }, [api_element("div", stc1, [api_custom_element("wds-icon-interactive", _wdsIconInteractive, {
    props: {
      "icon": "arrow_left",
      "size": "small",
      "ariaLabel": $cmp.packageFilesCollapseTree,
      "name": "hide-file-tree"
    },
    key: 2,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleToggleTree)),
      "analytics": _m1 || ($ctx._m1 = api_bind($cmp.handleTreeToggleAnalytics))
    }
  }), api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.packageFilesHeading))])]), api_element("div", stc2, [api_custom_element("listing-search-input", _listingSearchInput, {
    classMap: stc3,
    props: {
      "variant": "compact",
      "iconSize": "xsmall",
      "placeholder": $cmp.packageFilesSearchPlaceholder,
      "value": $cmp.searchQuery
    },
    key: 6,
    on: {
      "searchinput": _m2 || ($ctx._m2 = api_bind($cmp.handleSearchInput))
    }
  })]), api_element("div", stc4, [$cmp.treeIsEmpty ? api_static_fragment($fragment2, 9, [api_static_part(1, null, api_dynamic_text($cmp.packageFilesEmpty))]) : null, !$cmp.treeIsEmpty ? $cmp.hasNoFilteredResults ? api_static_fragment($fragment3, 11, [api_static_part(1, null, api_dynamic_text($cmp.packageFilesNoMatches))]) : null : null, !$cmp.treeIsEmpty ? !$cmp.hasNoFilteredResults ? api_custom_element("wds-file-tree", _wdsFileTree, {
    props: {
      "nodes": $cmp.filteredNodes,
      "selectedPath": $cmp.selectedPath,
      "filtering": $cmp.isFiltering
    },
    key: 12,
    on: {
      "select": _m3 || ($ctx._m3 = api_bind($cmp.handleTreeSelect)),
      "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleTreeAnalytics))
    }
  }) : null : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3ihqp0p296s";
tmpl.legacyStylesheetToken = "undefined-_skillFileBrowser";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
